"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var FormComponent_1 = require("@/pages/common/components/FormComponent");
var Validator_1 = require("@/utils/Validator");
var SignupFormComponent = /** @class */ (function (_super) {
    __extends(SignupFormComponent, _super);
    function SignupFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onBlurHandlers = {
            email: _this.onBlurHandler('email', [Validator_1.required, Validator_1.email]),
        };
        return _this;
    }
    SignupFormComponent.prototype.render = function () {
        var _a = this.state, form = _a.form, ui = _a.ui, tForm = _a.tForm, onFormSubmit = _a.onFormSubmit;
        var buttonClass = "o-btn o-btn--primary o-btn--long " + (ui.isLoading ? 'o-btn--loading' : '');
        var emailFieldClass = classnames_1.default([
            'c-forms__field',
            {
                'c-forms__field--disabled': ui.isLoading,
            },
        ]);
        return (React.createElement("form", { className: "c-forms", id: "signup-form-component", onSubmit: this.onSubmitHandler() },
            this.renderErrors(),
            React.createElement("div", { className: "c-login__login" },
                React.createElement("div", { className: "c-forms__row" },
                    React.createElement("div", { className: "c-forms__cols" },
                        React.createElement("div", { className: "c-forms__col" },
                            React.createElement("div", { className: "c-forms__fields" },
                                React.createElement("div", { className: emailFieldClass },
                                    React.createElement("input", { id: "signupInputEmail", disabled: ui.isLoading, type: "email", className: "c-forms__input", placeholder: tForm.email, value: form.email, onChange: this.onChangeHandler('email'), onBlur: this.onBlurHandlers.email }))))),
                    this.renderError('email'))),
            React.createElement("div", { className: "c-forms__row" },
                React.createElement("div", { className: "c-forms__col c-forms__col--range" },
                    React.createElement("button", { id: "signupSubmitButton", className: buttonClass, disabled: ui.isLoading, type: "submit" }, ui.isLoading ? '' : tForm.submit)))));
    };
    return SignupFormComponent;
}(FormComponent_1.default));
exports.default = SignupFormComponent;
